import { render } from "./NewRecordView.vue?vue&type=template&id=6bb23548&scoped=true"
import script from "./NewRecordView.vue?vue&type=script&lang=js"
export * from "./NewRecordView.vue?vue&type=script&lang=js"

import "./NewRecordView.vue?vue&type=style&index=0&id=6bb23548&scoped=true&lang=css"

import exportComponent from "/home/Daten/Entwicklung/repositories/bdl_ui/de.stone.bdl.management.ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bb23548"]])

export default __exports__